export default "__VITE_ASSET__nNzleqr6__"